import React, {Fragment, useEffect, useState} from "react";
import {notifyError, questionHasWeightage,} from "../../utils/helpers";
import { useTranslation } from "react-i18next";
import {
    BUTTON,
    GRADE_SCHEMA,
    QUESTION_TYPES,
    TEXTBOX,
} from "../../utils/constants";
import {Modal} from "react-bootstrap";
import YuJaButton from "../standardization/YuJaButton";
import { ReactComponent as ModalClose } from "../../images/modal_close.svg";
import loadingJson from "../../animations/LoadingDots.json";
import {YuJaTextBox} from "../standardization/YuJaTextBox";
import {InstitutionApiCalls} from "../../apis/InstitutionApiCalls";
import Lottie from "react-lottie";
import {convertMHOptionMap, resetCorrectAnswer} from "../../utils/questionUtils";
import styles from "../../pages/GradeBookPage/GradeQuestion.module.css";
import questionClasses from "../../questions/questions.module.css"
import reactStringReplace from "react-string-replace";
import { ReactComponent as CORRECT_ICON } from "../../images/grade-question-correct-icon.svg";
import {ReactComponent as ARROW} from "../../images/arrow_right_black.svg";
import classes from "../../questions/questions.module.css";
import {useLocalStorageNew} from "../../hooks/useLocalStorageNew";
import {ReactComponent as BLINK} from "../../images/blink_purple.svg";


export default function QuestionGenerateModal({
                                                  setModalShow,
                                                  show,
                                                  gradeSchema,
                                                  selectedQuestion,
                                                  questions,
                                                  setQuestions,
                                                  resetQueTitle,
}) {
    const { t } = useTranslation();
    const {questionType} = selectedQuestion;
    const {questionGenerate} = InstitutionApiCalls();
    const [ ,getHostResource] = useLocalStorageNew(window.location.hostname, {});
    const {platformSetting={}} = getHostResource();
    const {privateEVPLink=""} = platformSetting;

    const [videoLink, setVideoLink] = useState("");

    const [generatedQuestion, setGeneratedQuestion] = useState({});
    const [generatedVideoLink, setGeneratedVideoLink] = useState("");


    const [isProcessing, setIsProcessing] = useState(false);

    const LottieOptions = {
        loop: true,
        autoplay: true,
        animationData: loadingJson,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice",
        }
    };


    const handleClose = () =>{
        setModalShow(false);
    };

    const resetStatus = () => {
        setIsProcessing(false);
        setVideoLink("");
        setGeneratedQuestion({});
        setGeneratedVideoLink("");
    }

    const handleGenerate = async () => {
        if (!videoLink.includes(privateEVPLink)) {
            notifyError(t("genAI.invalidVideoLinkDomain"));
            return;
        }

        const match = videoLink.match(/v=(\d+)/);
        if (!match) {
            notifyError(t("genAI.invalidVideoLink"));
            return;
        }

        setIsProcessing(true);
        // await delay(3000);
        // setGeneratedQuestion({...selectedQuestion, ...{
        //         "queTitle": "According to Scott Koh, why is video an important tool for entrepreneurs?",
        //         "optionsMap": {
        //             "a": "To showcase technical expertise",
        //             "b": "To connect with audience through authentic storytelling",
        //             "c": "To reduce marketing costs",
        //             "d": "To demonstrate product features"
        //         },
        //         "correctAnswers": ["b"]
        //     }
        // });
        // setGeneratedVideoLink(videoLink);
        // setIsProcessing(false);
        questionGenerate(videoLink, questionType).then((response) => {
            if (!response) {
                return;
            }
            let returnQueObj = !!response ? JSON.parse(response.match(/\{[\s\S]*}/)[0]) : {};
            setGeneratedQuestion({...selectedQuestion, ...returnQueObj});
            setGeneratedVideoLink(videoLink);
        }).finally(() => setIsProcessing(false));
    }


    const handleApply = () => {
        const newQuestions = [];
        questions.forEach((q) => {
            if (q.serialNo === selectedQuestion.serialNo) {

                const newQuestion = JSON.parse(JSON.stringify(generatedQuestion));
                newQuestion.image = "";
                newQuestion.imageURL = "";
                newQuestion.directLinkEvp = videoLink;
                if (newQuestion.questionType === QUESTION_TYPES.MH.name) {
                    newQuestion.optionsMap = convertMHOptionMap(newQuestion.correctAnswers);
                }
                if (!questionHasWeightage(newQuestion)) {
                    newQuestion.correctAnswers = newQuestion.questionType !== QUESTION_TYPES.MH.name
                        ? resetCorrectAnswer(newQuestion.questionType) : newQuestion.correctAnswers;
                }

                newQuestions.push(newQuestion);
            } else {
                newQuestions.push({...q});
            }
        });

        if (generatedQuestion.questionType === QUESTION_TYPES.FITB.name && !!resetQueTitle) {
            resetQueTitle(generatedQuestion.queTitle);
        }

        setQuestions(newQuestions);
        setModalShow(false);
    }





    useEffect(() => {
        if (show) {
            resetStatus();
        }
    }, [show]);



    const renderAnswer = () => {
        const { queTitle, questionType, weightage, optionsMap, correctAnswers=[]} = generatedQuestion;
        const gradeEnabled = gradeSchema !== GRADE_SCHEMA.UNGRADED && !!weightage;

        switch (questionType) {
            case QUESTION_TYPES.MCSS.name:
                return (
                    <div style={{width: "100%", display: "flex", flexDirection: "column", gap: 5}}>
                        <span style={{fontWeight: "600"}}>{t("poll.optionsLabel")} </span>
                        {Object.keys(optionsMap).map((optIdx, index) => {
                            if (!!gradeEnabled) {
                                return (
                                    <div
                                        tabIndex={0}
                                        key={index}
                                        className={`${styles.optionBar} ${correctAnswers.includes(optIdx) ? styles.correct  : ""}`}
                                    >
                                        <span className={`${questionClasses.optionIndex} ${correctAnswers.includes(optIdx) ? questionClasses.correct : ""}`}>
                                            {optIdx.toUpperCase()}
                                        </span>
                                        <span style={{fontSize: 15}}>{optionsMap[optIdx]}</span>
                                    </div>
                                );
                            } else {
                                return (
                                    <div
                                        tabIndex={0}
                                        key={index}
                                        className={styles.optionBar}
                                    >
                                        <span className={questionClasses.optionIndex}>
                                            {optIdx.toUpperCase()}
                                        </span>
                                        <span style={{fontSize: 15}}>{optionsMap[optIdx]}</span>
                                    </div>
                                );
                            }
                        })}
                    </div>
                );
            case QUESTION_TYPES.TF.name:
                return (
                    <div style={{width: "100%", display: "flex", flexDirection: "column", gap: 5}}>
                        <span style={{fontWeight: "600"}}>{t("poll.optionsLabel")} </span>
                        {optionsMap.map((option, index) => {
                            if (!!gradeEnabled) {
                                return (
                                    <div
                                        key={index}
                                        className={`${styles.optionBar}  ${correctAnswers === option ? styles.correct : ""}`}
                                        style={{fontSize: 15}}
                                    >
                                        {option}
                                    </div>
                                );
                            } else {
                                return (
                                    <div key={index} className={styles.optionBar} style={{fontSize: 15}}>{option}</div>
                                );
                            }
                        })}
                    </div>
                );
            case QUESTION_TYPES.WC.name:
            case QUESTION_TYPES.SA.name:
            case QUESTION_TYPES.IB.name:
            case QUESTION_TYPES.RETRO.name:
            case QUESTION_TYPES.BS.name:
            case QUESTION_TYPES.OE.name:
                return (<></>);
            case QUESTION_TYPES.FITB.name:
                let blankNameArr = Object.keys(correctAnswers).map(str => `\\(${str}\\)`);
                const regex = new RegExp(`(${blankNameArr.join("|")})`, "g");
                return (
                    <div style={{width: "100%", display: "flex", flexDirection: "column", gap: 5}}>
                        <span style={{fontWeight: "600"}}>{t("common.questionLabel")}</span>
                        <span className={styles.regularText} style={{lineHeight: "unset"}}>
                               {reactStringReplace(queTitle, regex, (blank, i, o) => {
                                   const match = !!blank ? blank.match(/\(([^)]+)\)/) : null;
                                   if (!match) {
                                       return "";
                                   }
                                   const blankName = match[1];

                                   return (
                                       <span style={{display: "inline-block", verticalAlign: "middle"}}>
                                           <span
                                               tabIndex={0}
                                               className={`${styles.optionBar} ${styles.correct}`}
                                               style={{width: "fit-content", padding: "5px 10px", margin: 2, fontSize: 15}}
                                           >
                                               <span
                                                   className={`${questionClasses.optionCheckBox} ${questionClasses.active}`}>
                                                   <CORRECT_ICON/>
                                               </span>
                                               {correctAnswers[blankName]}
                                           </span>
                                       </span>
                                   );

                               })}
                          </span>
                    </div>
            )
                ;
            case QUESTION_TYPES.MH.name:
                return (
                    <>
                        <div className={questionClasses.MHGridLayoutContainer}>
                            <span className={questionClasses.MHLeftContainer} style={{fontWeight: "600"}}>
                                {t("questionBuilder.premiseLabel")}
                            </span>
                            <span className={questionClasses.MHMidContainer}/>
                            <span className={questionClasses.MHRightContainer}
                                  style={{fontWeight: "600"}}>{gradeEnabled ? t("poll.correctResponseText") : t("poll.responsesHeader")}</span>

                            {correctAnswers.map((value, index) => {
                                if (value.length < 2) {
                                    return <Fragment key={index}/>
                                }
                                return (
                                    <Fragment key={index}>
                                        <div className={`${styles.optionBar} ${questionClasses.MHLeftContainer}`} style={{fontSize: 15}}>
                                            {value[0]}
                                        </div>
                                        <span className={classes.MHMidContainer}>
                                          <ARROW/>
                                        </span>
                                        <div className={`${styles.optionBar} ${questionClasses.MHRightContainer}`} style={{fontSize: 15}}>
                                            {value[1]}
                                        </div>
                                    </Fragment>
                                );
                            })}

                        </div>
                    </>
                );
            case QUESTION_TYPES.RK.name:
                return (
                    <div style={{width: "100%", display: "flex", flexDirection: "column", gap: 5}}>
                        <span style={{fontWeight: "600"}}>
                            {t("poll.optionsLabel")}
                        </span>
                        {optionsMap.map((key, index) =>
                            <div key={index} className={styles.optionBar} style={{fontSize: 15}}>
                                <span
                                    className={`${questionClasses.optionIndex}`}
                                    style={{width: "auto", padding: 5}}
                                >
                                    {(index + 1)}
                                </span>
                                <span>{key}</span>
                            </div>
                        )}

                    </div>
                );
            default:
                return <></>;
        }
    }

    return (
        <Modal
            id="form-modal"
            show={show}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop={true}
            dialogClassName= {"qp-modal"}
        >
            <>
                <ModalClose
                    tabIndex={0}
                    role={BUTTON}
                    aria-label={t("questionBank.closeModalAria")}
                    onClick={handleClose}
                    className="modal-close"
                    style={{width: "24px", height: "24px"}}
                />
                <Modal.Header
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <Modal.Title tabIndex={0} role={TEXTBOX} aria-label={t("questionBank.modalTitle")} className="modal-title" id="contained-modal-title-vcenter">
                        {!!isProcessing && t("genQuestion.generatingQuestionText")}
                        {!isProcessing && !!generatedVideoLink && t("poll.previewQuestionText")}
                        {!isProcessing && !generatedVideoLink && t("genQuestion.generateQuestionText")}
                    </Modal.Title>
                </Modal.Header>
            </>


            <Modal.Body style={{display: "flex", flexDirection: "column", gap: 25, fontSize: 15, maxHeight: 600, overflowY: "auto"}}>
                {!!isProcessing &&
                    <>
                        <Lottie
                            options={LottieOptions}
                            height={200}
                            style={{overflow: 'unset', width: "unset", cursor: "default", marginBottom: 30}}
                            isClickToPauseDisabled={true}
                        />

                        <span style={{fontSize: 20, lineHeight: 1.4, fontWeight: "600", textAlign: "center"}}>{t("genQuestion.generateQuestionWaitingTitle")}</span>
                        <span style={{fontSize: 15, fontWeight: "400", textAlign: "center"}}>{t("genQuestion.generateQuestionWaitingDesc")}</span>
                    </>
                }

                {!isProcessing &&
                    <>
                        <span style={{color: "#6B6B6B", fontSize: 15, fontWeight: "400"}}>
                            {!generatedVideoLink ? t("genQuestion.generateDescription") : t("genQuestion.generateQuestionPreviewDesc")}
                        </span>

                        <div>
                            <span style={{fontSize: 15, fontWeight: "600"}}>{t("integration.videoPlatformLinkText")}</span>
                            <div style={{height: 5}}/>
                            <div style={{display: "flex", alignItems: "center", gap: 10}}>
                                <YuJaTextBox
                                    value={videoLink}
                                    containerStyle={{flex: 1, minWidth: 0, height: 40, fontSize: 15}}
                                    onChange={e => setVideoLink(e.target.value)}
                                    placeholder={t("questionBuilder.enterDirectLink")}
                                />

                                <YuJaButton
                                    disabled={!videoLink}
                                    onClick={handleGenerate}
                                    style={{width: 120, height: 35, display: "flex", alignItems: "center", justifyContent: "center"}}
                                >
                                    <BLINK style={{flexShrink: 0, marginRight: 3}}/>
                                    {!!generatedVideoLink && generatedVideoLink === videoLink ? t("questionBuilder.regenerate") : t("questionBuilder.generate")}
                                </YuJaButton>
                            </div>
                        </div>


                        {!!generatedVideoLink &&
                            <>
                                {generatedQuestion.questionType !== QUESTION_TYPES.FITB.name &&
                                    <span style={{display: "flex", gap: 5, flexDirection: "column"}}>
                                        <span style={{fontWeight: "600"}}>{t("common.questionLabel")}</span>
                                        <span>{generatedQuestion.queTitle}</span>
                                    </span>
                                }

                                {renderAnswer()}
                            </>
                        }

                    </>
                }
            </Modal.Body>


            <Modal.Footer>
                <div style={{
                    display: "flex",
                    width: "100%",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    gap: 10
                }}>
                    <span style={{
                        display: "flex",
                        width: "100%",
                        alignItems: "center",
                        justifyContent: "flex-end",
                        gap: 10
                    }}>
                        <YuJaButton
                            onClick={handleClose}
                            type={"secondary"}
                            style={{width: 120, height: 35, display: "flex", alignItems: "center", justifyContent: "center"}}
                        >
                           {t("common.cancel")}
                        </YuJaButton>

                        {!isProcessing && !!generatedVideoLink &&
                            <YuJaButton
                                onClick={handleApply}
                                style={{width: 120, height: 35, display: "flex", alignItems: "center", justifyContent: "center", whiteSpace: "nowrap"}}
                            >
                                {t("questionBuilder.addQuestionButton")}
                            </YuJaButton>
                        }


                    </span>
                </div>
            </Modal.Footer>
        </Modal>
    );
}